import { Component } from '@angular/core';

@Component({
  selector: 'app-fitness',
  standalone: true,
  imports: [],
  templateUrl: './fitness.component.html',
  styleUrl: './fitness.component.css'
})
export class FitnessComponent {

}
